export default __webpack_public_path__ + "static/media/benefit_6@3x.75b7b7e5.png";